import { Branch } from "./branch";
import { User } from "./user";

export class Customer {
  public id: number;
  public dni: string;
  public name: string;
  public lastName: string;
  public email: string;
  public cellphone: string;
  public address: string;
  public zipCode: string;
  public city: string;
  public checkingAccountEnabled: boolean;
  public password?: string;
  public totalRewardPoints?: number;
  public listPrice: number;
  public user: User;
  public alternativePhone: string;
  public district: string;
  public state: string;
  public preferedContactTime: string;
  public enabled: boolean;
  branch: Branch;
  saldoFavor: number;

  constructor() {
    this.id = null;
    this.dni = null;
    this.name = null;
    this.lastName = null;
    this.email = null;
    this.cellphone = null;
    this.address = null;
    this.zipCode = null;
    this.city = null;
    this.checkingAccountEnabled = null;
    this.password = null;
    this.totalRewardPoints = null;
    this.listPrice = 1;
    this.user = new User();
    this.alternativePhone = null;
    this.district = null;
    this.state = null;
    this.preferedContactTime = null;
    this.enabled = true;
    this.branch = new Branch();
    this.saldoFavor = 0;
  }
}

export class CustomerFilter {
  public name: string;
  public lastname: string;
  public dni: string;
  public checking_account_enable: boolean;
  public onlyenabled: boolean;

  constructor() {
    this.name = "";
    this.lastname = "";
    this.dni = "";
    this.checking_account_enable = false;
    this.onlyenabled = true;
  }
}
